import Vue from "vue";
import Router from "vue-router";

import AmbisMeter from "@/modules/ambis_meter/router/ambis_meter.js";
import AmbisTest from "@/modules/ambis_test/router/ambis_test.js";
import Auth from "@/modules/auth/router/auth.js";
import Home from "@/modules/home/router/home.js";
import Itembank from "@/modules/itembank/router/itembank.js";
import Kodifikasi from "@/modules/kodifikasi/router/kodifikasi.js";
import Konsul from "@/modules/konsul/router/konsul.js";
import LiveClass from "@/modules/live_class/router/liveclass.js";
import LiveClassTeacher from "@/modules/live_class_teacher/router/liveclassteacher.js";
import LiveClassReport from "@/modules/live_class_report/router/liveclassreport.js";
import ModulBelajar from "@/modules/modul_belajar_2022/router/modul_belajar.js";
import ModulPembelajaranOld from "@/modules/modul_belajar_old/router/modul_belajar_old.js";
import NotificationsTemplate from "@/modules/notifications_template/router/notifications_template.js";
import OssConfigs from "@/modules/oss_configs/router/oss_config.js";
import OmniLearning from "@/modules/omnilearning/router/omnilearning.js";
import Pembayaran from "@/modules/pembayaran/router/pembayaran.js";
import PopUpAds from "@/modules/pop_up_ads/router/pop_up_ads.js";
import Serial from "@/modules/serial/router/serial.js";
import Tryout from "@/modules/tryout/router/tryout.js";
import TryoutGroup from "@/modules/tryout_group/router/tryout_group.js";
import TryoutMembers from "@/modules/tryout_members/router/tryout_members.js";
import TryoutReport from "@/modules/tryout_report/router/tryoutreport.js";
import UserGroup from "@/modules/user_group/router/user_group.js";
import Usman from "@/modules/usman/router/usman.js";
import VdPembelajaran from "@/modules/vd_pembelajaran/router/video.js";
import CodeActivation from "@/modules/code_activation/router/code_activation.js";
import Partnership from "@/modules/partnership/router/partnership.js";

Vue.use(Router);

const router = new Router({
    routes: [
        ...AmbisMeter,
        ...AmbisTest,
        ...Auth,
        ...Home,
        ...Itembank,
        ...Kodifikasi,
        ...Konsul,
        ...LiveClass,
        ...LiveClassTeacher,
        ...LiveClassReport,
        ...ModulBelajar,
        ...ModulPembelajaranOld,
        ...NotificationsTemplate,
        ...OssConfigs,
        ...Pembayaran,
        ...PopUpAds,
        ...Serial,
        ...Tryout,
        ...TryoutGroup,
        ...TryoutMembers,
        ...TryoutReport,
        ...UserGroup,
        ...Usman,
        ...VdPembelajaran,
        ...CodeActivation,
    ],
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
    linkExactActiveClass: "active",
});

export default router;



// WEBPACK FOOTER //
// ./src/modules/global/router/index.js